import { render } from "./CardShortInfo.vue?vue&type=template&id=25d40a79"
import script from "./CardShortInfo.vue?vue&type=script&lang=js"
export * from "./CardShortInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__